import { LegacyGraphicRef, resolveGraphicRef } from 'src/config/graphicRefs';

export function getGraphicRef(graphicRef: string) {
  const legacyRef = resolveGraphicRef(graphicRef);

  const matchesRef = (ref: LegacyGraphicRef) => legacyRef === ref;

  return {
    legacyRef,
    matchesRef,
  };
}
